import Configuration from '@/api/utils/Configuration';
import { getBaseUrl } from '@/api/common/Axios';

export function getAuthURL() {
  const authURL = Configuration.value('VUE_APP_AUTH_API_BASE_URL');
  if (authURL !== undefined && authURL !== '') return authURL;

  //use default value
  const baseURL = getBaseUrl();
  const hostname = new URL(baseURL).origin;

  return hostname + '/api/auth';
}

export function getInfoURL() {
  const authURL = Configuration.value('VUE_APP_INFO_API_BASE_URL');
  if (authURL !== undefined && authURL !== '') return authURL;

  //use default value
  const baseURL = getBaseUrl();
  const hostname = new URL(baseURL).origin;

  return hostname + '/api/app';
}
